<script setup>
import { Link } from '@inertiajs/vue3'
import { computed } from 'vue'
import { getColleagueColor } from '../../../composables/useReservationsCalendar.js'
import { getInitials } from '../../../../../helpers.js'

const props = defineProps({
    open:               { type: Boolean, default: false },
    allEmployees:       { type: Array,   default: () => [] },
    visibleColleagueIds:{ type: Set,     default: () => new Set() },
    anchorRect:         { type: Object,  default: null },
})

const emit = defineEmits(['close', 'toggle-colleague'])

const popoverStyle = computed(() => {
    const left = props.anchorRect ? props.anchorRect.right + 8 : 268
    return { top: '80px', left: `${left}px` }
})
</script>

<template>
    <Teleport to="body">
        <Transition name="cp-scrim">
            <div v-if="open" class="fixed inset-0 z-[140]" @click="emit('close')"/>
        </Transition>

        <Transition name="cp">
            <div
                v-if="open"
                class="fixed z-[141] w-[400px] bg-white border border-neutral-200 rounded-2xl
                       shadow-[0_24px_60px_-16px_rgba(15,17,21,.25),0_4px_16px_rgba(15,17,21,.07)]
                       overflow-hidden"
                :style="popoverStyle"
            >
                <!-- Header -->
                <div class="flex items-center justify-between px-4 py-3 border-b border-neutral-100">
                    <span class="text-sm font-semibold text-neutral-800">{{ $t('common.colleagues') }}</span>
                    <div class="flex items-center gap-2">
                        <Link
                            href="/app/workers"
                            class="text-[11px] text-blue-500 font-medium hover:text-blue-700"
                            @click="emit('close')"
                        >
                            Spravovat
                        </Link>
                        <button
                            class="w-7 h-7 rounded-full flex items-center justify-center text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700"
                            @click="emit('close')"
                        >
                            <i class="pi pi-times !text-xs"/>
                        </button>
                    </div>
                </div>

                <!-- Grid kolegů -->
                <div class="px-3 py-2 max-h-[70vh] overflow-y-auto">
                    <div class="grid grid-cols-2 gap-0.5">
                        <button
                            v-for="(employee, i) in allEmployees"
                            :key="employee.id"
                            class="flex items-center gap-2 px-2 py-2 rounded-lg text-left hover:bg-neutral-50 transition-colors"
                            :class="visibleColleagueIds.has(employee.id) ? '' : 'opacity-40'"
                            @click="emit('toggle-colleague', employee.id)"
                        >
                            <!-- Eye -->
                            <i
                                class="!text-[11px] flex-shrink-0 w-3.5 transition-colors"
                                :class="visibleColleagueIds.has(employee.id) ? 'pi pi-eye' : 'pi pi-eye-slash text-neutral-300'"
                                :style="visibleColleagueIds.has(employee.id) ? { color: getColleagueColor(i) } : {}"
                            />
                            <!-- Avatar -->
                            <div
                                class="w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-semibold text-white flex-shrink-0"
                                :style="{ background: getColleagueColor(i) }"
                            >
                                {{ getInitials(employee.name) }}
                            </div>
                            <!-- Jméno -->
                            <span class="flex-1 text-[12px] font-medium text-neutral-800 truncate min-w-0 leading-tight">
                                {{ employee.name }}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<style scoped>
.cp-scrim-enter-active, .cp-scrim-leave-active { transition: opacity .1s; }
.cp-scrim-enter-from, .cp-scrim-leave-to       { opacity: 0; }

.cp-enter-active { transition: opacity .15s ease, transform .15s cubic-bezier(.25,1,.3,1); }
.cp-leave-active { transition: opacity .1s ease; }
.cp-enter-from   { opacity: 0; transform: translateX(-8px) scale(.97); }
.cp-leave-to     { opacity: 0; }
</style>
